import React from "react";

// utils
import {createURLQuery} from '../utility/utils';


// Response logic: in this model response.json is used in backend. 
// since the status need to fixed and i some cases a custom message shoudl be catched.

    const getAPIGWPath = (sRoute) => {
        const api_gw_url  = process.env.REACT_APP_API_GW_URL;
        let sPath         =  api_gw_url + sRoute;

        return(sPath);

        // return(sRoute); // local testing with 4000
    }


    const signup = async (oEntry) => {

     try {

        let sPath = getAPIGWPath('/user/signup'),
            oReqOption,
            srvResp,
            oReqBdy, 
            resJSON, 
            data;
        
        oReqOption = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(oEntry)
        };

        srvResp = await fetch(sPath, oReqOption);
        data    = await srvResp.json();

        data.status = srvResp.status;

        return data;

      } catch(e) {

        console.log(e);
        alert('technical error. couldnt signup');
      }

    };

    const login = async (oEntry) => {

        try {

        let sPath = getAPIGWPath('/user/login'),
            oReqOption,
            srvResp,
            data;

        oReqOption = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify(oEntry)
        };

        srvResp = await fetch(sPath, oReqOption);
        data    = await srvResp.json();

        data.status = srvResp.status;

        return data;

        } catch(e) {
            console.log(e);
        }

    };

    const logout = async(oEntry) => {

        try {
          let sPath   = getAPIGWPath('/user/logout'),
              srvReq  = fetch(sPath,{ method:'POST', credentials:'include'}),
              srvResp = await srvReq,
              resJSON = await srvResp.json(),
              data    = await resJSON;

            //   return data;
             data.status = srvResp.status;
              return data;

      } catch(e) {
        alert('error couldnt logout');
      }
    };

    const getUserInfo = async () => {

        try {
            let oResult = {},
                sPath   = getAPIGWPath('/user/userInfo'),
                srvResp = await fetch(sPath),
                resJSON = await srvResp.json(),
                data    = await resJSON;

                oResult.status = srvResp.status;
                oResult.data   = data;

                return oResult;

        } catch(e) {
            alert('Technical Error. Failed to fetch User Information');
        }

    };

    const refresh = async () => {

        try {
            let sPath   = getAPIGWPath('/user/refresh'),
                srvResp = await fetch(sPath),
                resJSON = await srvResp.json(),
                data    = await resJSON;

                return(data);

        } catch(e) {
            alert('Technical Error. couldnt refresh data');
        }




    }


export { signup, login, logout, getUserInfo, refresh}